import { createStore } from 'vuex'
import type { AuthUser } from '@/types/auth'

export interface State {
  user: AuthUser | null
  userTeamIds: number[]
}

// sessionStorage é limpo pelo navegador ao fechar a aba/janela (mas sobrevive
// a um F5) — usado em main.ts pra distinguir "recarregou a página" de "fechou
// o navegador/aba" e forçar logout só no segundo caso. Ver checkStaleSession.
export const SESSION_ACTIVE_KEY = 'wootdash_session_active'

export default createStore<State>({
  state: {
    user: null,
    userTeamIds: [],
  },
  getters: {
    isLoggedIn:  (s) => !!s.user?.wootdash_token,
    isAdmin:     (s) => s.user?.role === 'administrator',
    authUser:    (s) => s.user,
    userTeamIds: (s) => s.userTeamIds,
  },
  mutations: {
    SET_USER(state, user: AuthUser | null) {
      state.user = user
      if (user) {
        localStorage.setItem('auth_user', JSON.stringify(user))
        try { sessionStorage.setItem(SESSION_ACTIVE_KEY, '1') } catch { /* modo privado etc. */ }
      } else {
        localStorage.removeItem('auth_user'); localStorage.removeItem('auth_team_ids')
        try { sessionStorage.removeItem(SESSION_ACTIVE_KEY) } catch { /* ignore */ }
      }
    },
    /** Token renovado/novo login: troca só o token (sem trocar o objeto — os watch(authUser) não reiniciam nada). */
    SET_TOKEN(state, token: string) {
      if (!state.user) return
      state.user.wootdash_token = token
      localStorage.setItem('auth_user', JSON.stringify(state.user))
    },
    SET_TEAM_IDS(state, ids: number[]) {
      state.userTeamIds = ids
      if (ids.length) localStorage.setItem('auth_team_ids', JSON.stringify(ids))
      else localStorage.removeItem('auth_team_ids')
    },
  },
  actions: {
    login({ commit }, user: AuthUser) { commit('SET_USER', user) },
    logout({ commit }) { commit('SET_USER', null); commit('SET_TEAM_IDS', []) },
    setUserTeams({ commit }, ids: number[]) { commit('SET_TEAM_IDS', ids) },
    restoreSession({ commit }) {
      try {
        const u = localStorage.getItem('auth_user')
        // Sessão salva antes do rename ChatPlatform → WootDash (2026-10-13) não tem
        // wootdash_token (e o JWT dela nem vale mais) — descarta e cai no login.
        const user = u ? JSON.parse(u) : null
        if (user?.wootdash_token) commit('SET_USER', user)
        else if (user) localStorage.removeItem('auth_user')
        const t = localStorage.getItem('auth_team_ids')
        if (t) commit('SET_TEAM_IDS', JSON.parse(t))
      } catch { /* ignore corrupt storage */ }
    },
  },
})
